import './StatusText.css';
import { useState, useEffect, ReactNode } from 'react'
import useDroneHubConnection from '../../hooks/DroneHubConnection';
import { HubStatusTextMessage, HubStatusTextSchema } from '../../asp/DroneHub';

interface MessageProps {
    text: string;
    time: string;
    severity: number;
}

interface StatusTextProps {
    imei: string;
    showMsgs: boolean;
    startMsgs: HubStatusTextMessage[];
}

function StatusText({ imei, showMsgs, startMsgs }: StatusTextProps): ReactNode {
    const droneHub = useDroneHubConnection();
    const [statusText, setStatusText] = useState<HubStatusTextMessage[]>([]);

    useEffect(() => {
        droneHub.connection.on('StatusText', (message: HubStatusTextMessage) => {
            const result = HubStatusTextSchema.safeParse(message);
            if (result.success) {
                setStatusText((prevText: HubStatusTextMessage[]) => {
                    // Фильтруем, оставляя только элементы с другим imei + 20 последних для этого imei
                    const filtered = prevText.filter((msg) => msg.imei !== result.data.imei);
                    const sameImei = prevText.filter((msg) => msg.imei === result.data.imei);

                    return [...filtered, ...sameImei.slice(-19), result.data]; // Оставляем только 20 последних
                });
            } else {
                console.error(result.error);
            }
        });
    }, [droneHub]);

    useEffect(() => {
        setStatusText(startMsgs);
    }, [startMsgs]);

    function Messages() {
        return (
            <>
                {statusText.filter(el => el.imei === imei).toReversed().map((el, index) =>
                    <Message
                        key={index}
                        text={el.message}
                        time={el.time}
                        severity={el.severity}
                    />
                )}
            </>
        )
    }

    function Message({ text, time, severity }: MessageProps) {
        return (
            <div className='message'>
                <div className='message-time t-normal t-grey'>{time}</div>
                <div className={'message-text t-big ' + getClassColor(severity)} >{text}</div>
            </div>
        )
    }

    function getClassColor(severity: number): string {
        if (severity <= 0) {
            return 'addition-white';
        }
        if (severity <= 2) {
            return 'addition-red';
        }
        if (severity <= 4) {
            return 'addition-yell';
        }
        return 'addition-white';
    }

    return (
        <>
            {imei &&
                <div className='status-text'>
                    {showMsgs && <Messages />}
                </div>
            }
        </>
    )
}

export default StatusText;